const FilterConst = {
  DATE: "date",
  DATE_RANGE: "date-range",
  BOOLEAN: "boolean",
  LOOKUP: "lookup",
  NUMBER: "number",
  SIMPLE_NUMBER: "simple-number"
};
export {
  FilterConst
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmlsdGVyQ29uc3QuanMiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9maWx0ZXJDb25zdC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgRmlsdGVyQ29uc3QgPSB7XG5cdERBVEU6IFwiZGF0ZVwiLFxuXHREQVRFX1JBTkdFOiBcImRhdGUtcmFuZ2VcIixcblx0Qk9PTEVBTjogXCJib29sZWFuXCIsXG5cdExPT0tVUDogXCJsb29rdXBcIixcblx0TlVNQkVSOiBcIm51bWJlclwiLFxuXHRTSU1QTEVfTlVNQkVSOiBcInNpbXBsZS1udW1iZXJcIixcbn07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQVksTUFBQyxjQUFjO0FBQUEsRUFDMUIsTUFBTTtBQUFBLEVBQ04sWUFBWTtBQUFBLEVBQ1osU0FBUztBQUFBLEVBQ1QsUUFBUTtBQUFBLEVBQ1IsUUFBUTtBQUFBLEVBQ1IsZUFBZTtBQUNoQjsifQ==
